import matchService from '@/services/match'
import teamService from '@/services/team'

// Short cache window so components mounted/rotated in quick succession (e.g. the
// LiveData.vue pregame/full-time tab rotation) reuse the same match/team payload
// instead of each issuing its own network request, while still refreshing on the
// next rotation cycle so live scores/stats don't go stale for long.
const CACHE_TTL_MS = 10000

function isFresh(entry) {
    return Boolean(entry && entry.data && (Date.now() - entry.fetchedAt) < CACHE_TTL_MS)
}

export default {
    namespaced: true,
    state: {
        matches: {},
        teams: {}
    },
    mutations: {
        setMatch(state, { id, data }) {
            state.matches = { ...state.matches, [id]: { data, fetchedAt: Date.now(), promise: null } }
        },
        setMatchPromise(state, { id, promise }) {
            state.matches = { ...state.matches, [id]: { ...(state.matches[id] || {}), promise } }
        },
        setTeam(state, { id, data }) {
            state.teams = { ...state.teams, [id]: { data, fetchedAt: Date.now(), promise: null } }
        },
        setTeamPromise(state, { id, promise }) {
            state.teams = { ...state.teams, [id]: { ...(state.teams[id] || {}), promise } }
        }
    },
    actions: {
        fetchMatch({ state, commit }, { matchId, force = false } = {}) {
            const entry = state.matches[matchId]

            if (!force && isFresh(entry)) {
                return Promise.resolve(entry.data)
            }

            if (!force && entry && entry.promise) {
                return entry.promise
            }

            const promise = matchService.getMatch(matchId).then(resp => {
                commit('setMatch', { id: matchId, data: resp.data })
                return resp.data
            })

            commit('setMatchPromise', { id: matchId, promise })
            return promise
        },
        fetchTeam({ state, commit }, { teamId, force = false } = {}) {
            const entry = state.teams[teamId]

            if (!force && isFresh(entry)) {
                return Promise.resolve(entry.data)
            }

            if (!force && entry && entry.promise) {
                return entry.promise
            }

            const promise = teamService.getTeam(teamId).then(resp => {
                commit('setTeam', { id: teamId, data: resp.data })
                return resp.data
            })

            commit('setTeamPromise', { id: teamId, promise })
            return promise
        }
    },
    getters: {
        getMatch: state => matchId => state.matches[matchId]?.data || null,
        getTeam: state => teamId => state.teams[teamId]?.data || null
    }
}
